import { baseRoute } from '../../../constants/routes';

export const QUIZ_ROUNDS_ROUTE = baseRoute + '/quiz-rounds';

export const GET_ROUNDS = 'GET_ROUNDS';
export const GET_ROUNDS_SUCCESS = 'GET_ROUNDS_SUCCESS';

export const ADD_ROUND = 'ADD_ROUND';
export const ADD_ROUND_SUCCESS = 'ADD_ROUND_SUCCESS';

export const UPDATE_ROUND = 'UPDATE_ROUND';
export const UPDATE_ROUND_SUCCESS = 'UPDATE_ROUND_SUCCESS';

export const DELETE_ROUND = 'DELETE_ROUND';
export const DELETE_ROUND_SUCCESS = 'DELETE_ROUND_SUCCESS';